import { Component, Input } from '@angular/core';

@Component({
  selector: 'sg-action-confirmation',
  templateUrl: './action-confirmation.component.html',
  styleUrls: ['./action-confirmation.component.scss'],
  standalone: false,
})
export class SgActionConfirmationComponent {
  @Input() iconSrc: string;
  @Input() title: string;
  @Input() message: string;

  constructor() {}
}
